/*
 * Trusted Circle color palette
 * ------------------------------------------------------------------
 * A curated 8-hue palette used to distinguish overlapping trusted-circle
 * alert radii on the map, and to match those rings with a legend chip
 * inside the ATM detail sheet.
 *
 * Design goals:
 * 1. Every colour must be readable on BOTH the dark map (near-black
 *    #0f0f10 base) and the light map (cream #eeece5 base). That rules
 *    out anything too pale (dies on cream) or too dark (dies on black).
 *    Chosen hues are all in the ~medium-saturated / medium-lightness
 *    band that pops against either surface.
 * 2. Deliberately no bright greens — we already use #00FF94 as the
 *    "ATM working" status colour. Reusing that green for a trusted
 *    circle would confuse users into thinking the ring means "ATM ok".
 * 3. Ordered so the first four are maximally distinct — most users
 *    only belong to 1-3 circles and will only ever see the head of
 *    the palette. Circles 5-8 use hues that are further from each
 *    other than from the first four (so a user with 4+ circles still
 *    gets distinguishable rings).
 * 4. `%` wraps around at 8 — users on the Pro tier can create up to
 *    10 circles; palette repeats for #9-10 (rare in practice and the
 *    duplicate ring almost never overlaps the same ATM at the same
 *    time given radius overlap semantics).
 */
export const TRUSTED_CIRCLE_PALETTE = [
  "#E11D48", // rose-600     — family / red-red urgency
  "#2563EB", // blue-600     — work / commute
  "#D97706", // amber-600    — school / friends
  "#7C3AED", // violet-600   — gym / social
  "#0891B2", // cyan-600     — weekend / travel
  "#DB2777", // pink-600     — hobby / community
  "#CA8A04", // yellow-600   — errands / neighbours
  "#4F46E5", // indigo-600   — spare (still distinct from blue-600)
];
